import React, {useEffect} from "react";
import CommonSection from "../shared/CommonSection";
import Newsletter from "../shared/Newsletter";
import AchievementsSection from "../shared/AchievementsSection";

import { Container, Row, Col } from "reactstrap";
import './../styles/about.css'
import { Helmet } from "react-helmet";
import Widget from "../components/WhyTravel/whytravelwithus";
import Subtitle from "../shared/Subtitle";
const About = () => {

  useEffect(() => {
    // Create a script element for the ElfSight widget
    const script = document.createElement("script");
    script.src =
      "https://static.elfsight.com/platform/platform.js";
    script.setAttribute("data-use-service-core", "");
    script.defer = true;

    // Append the script element to the body
    document.body.appendChild(script);

    // Clean up by removing the script when the component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
    <Helmet>
  <title>About Us - Your Trusted The Rustic Paths</title>

  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  <meta name="description" content="Discover the story of your trusted The Rustic Paths. We offer safe, reliable chauffeur and travel services across the country. Experience India's wonders with us!" />
  <meta name="keywords" content="Private driver India, private driver, chauffeur, travel services, India, safe, reliable, explore India, trusted, about us" />
  <meta name="author" content="The Rustic Paths" />

  <meta property="og:title" content="About Us - Your Trusted The Rustic Paths | Private Driver India" />
  <meta property="og:description" content="Discover the story of your trusted The Rustic Paths. Experience India's wonders with our safe and reliable chauffeur and travel services. Book your journey today!" />
   </Helmet>

      <CommonSection title={"About Us"} />
      <section>
        <Container>
          <Row>
            <Col lg='12'>
              <div className="about__content align-items-center justify-content-center">
                <h1  className="align-items-center justify-content-center">The Rustic Paths</h1>
                <br />
                <p>
                India is a country with a rich history and diverse culture, steeped in grandeur. From beautiful monuments to vibrant villages, India is known for its unique and stunning heritage that attracts millions of tourists each year.
                </p>
                <p>
                At The Rustic Paths, we believe that the heart of India lies in its rural areas, where traditional ways of life and ancient customs are still preserved. We curate customized tour itineraries and provide tour packages that offer sustainable and responsible tourism opportunities, showcasing the best of India’s heritage while empowering rural communities.
                </p>
                {/* Insert more information about your mission and services here */}
              </div>
            </Col>
            {/*--------------------------- Our Achievements Section Start--------------------------*/}
      <section>
              <Container>
                <Row>
                  <Col lg="12">
                    {/* <div style={{ backgroundColor: "#ffffff" }}>
                      <h2 align="center" className="services__subtitle">
                        Few of our achievements
                        
                      </h2>
                      
                    </div> */}
                    <Subtitle subtitle={"Few of our achievements"}/>
                  </Col>
                  <Col lg="12">
                    <AchievementsSection />
                  </Col>
                </Row>
              </Container>
            </section>

            {/*--------------------------- Our Achievements Section End--------------------------*/}
            <Col className='mt-6' lg="12">
              {/* Add the ElfSight testimonial widget div */}
              <div className="elfsight-app-67d8eea9-b408-49ad-8765-9edf92c75e9a"></div>
            </Col>
          </Row>
        </Container>
      </section>
      <section>
        <Widget/>
      </section>
      
      
      <Newsletter />
    </>
  );
};

export default About;